import { useQuery } from "@tanstack/react-query";
import { SEO } from "../components/shared/SEO";
import { PageHeader } from "../components/shared/PageHeader";
import { ProjectCard } from "../components/shared/ProjectCard";
import { CTABand } from "../components/shared/Sections";
import { IMAGES } from "../content/site";
import { api } from "../lib/api";

export default function Progetti() {
  const { data: projects = [], isLoading } = useQuery({ queryKey: ["projects"], queryFn: () => api.get("/projects").then((r) => r.data) });
  return (
    <>
      <SEO title="Progetti Immobiliari a Messina e in Italia | Home Haven" description="Scopri le operazioni immobiliari sviluppate da Home Haven: riqualificazione, frazionamento e valorizzazione di immobili a Messina e in Italia." image={IMAGES.exterior} />
      <PageHeader eyebrow="Projects" title="I nostri progetti immobiliari" image={IMAGES.exterior} text="Ogni progetto nasce dall'analisi dei numeri e prende forma attraverso progettazione, trasformazione e valorizzazione." />
      <section className="section bg-cream">
        <div className="container-hh">
          {isLoading && <div className="text-stone text-sm uppercase tracking-widest">Caricamento…</div>}
          <div data-testid="projects-grid" className="grid grid-cols-1 md:grid-cols-2 gap-12 md:gap-x-16 md:gap-y-24">
            {projects.map((p, i) => <ProjectCard key={p.id} p={p} index={i} />)}
          </div>
          {!isLoading && projects.length === 0 && <p className="lead">Nessun progetto pubblicato al momento.</p>}
        </div>
      </section>
      <CTABand dark eyebrow="Investitori" title="Vuoi partecipare al prossimo progetto?" primary={{ to: "/investitori", label: "Investi con noi", testId: "projects-cta-investi" }} secondary={{ to: "/proponi-immobile", label: "Proponi un immobile", testId: "projects-cta-proponi" }} />
    </>
  );
}
